/**
 * Labstep
 *
 * @module components/Folder/Form/ShowEdit/Name
 * @desc ShowEditName for Folder
 */

import { fieldName } from 'labstep-web/components/Folder/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderFormShowEditNameProps } from './types';

export const FolderFormShowEditName: React.FC<
  FolderFormShowEditNameProps
> = ({ folder }) => (
  <FormShowEditText
    entityName={Folder.entityName}
    entity={folder}
    field={fieldName}
  >
    {folder.name}
  </FormShowEditText>
);
